"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactTransitionGroup = require("react-transition-group");

var _MobileNavMenu = _interopRequireDefault(require("./components/MobileNavMenu"));

var _MobileSubNav = _interopRequireDefault(require("./components/MobileSubNav"));

var _Backdrop = _interopRequireDefault(require("./components/Backdrop"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var MOBILE_NAV_ITEMS = 4;

var MobileNavigation = function MobileNavigation(_ref) {
  var ariaLabel = _ref.ariaLabel,
      ariaLabelSubNavigation = _ref.ariaLabelSubNavigation,
      LinkComponent = _ref.LinkComponent,
      pathname = _ref.pathname,
      mobileMoreText = _ref.mobileMoreText,
      items = _ref.items;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isSubNavVisible = _useState2[0],
      setIsSubNavVisible = _useState2[1];

  var toggleSubNav = function toggleSubNav() {
    return setIsSubNavVisible(!isSubNavVisible);
  };

  var mainItems = [];
  var moreItems = [];

  if (items.length > MOBILE_NAV_ITEMS) {
    mainItems = items.slice(0, 3);
    moreItems = items.slice(3);
  } else {
    mainItems = items.slice(0);
  }

  var isMoreActive = !!moreItems.find(function (item) {
    return item.to === pathname;
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, moreItems.length > 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    "in": isSubNavVisible,
    timeout: 0,
    classNames: "fade-in"
  }, /*#__PURE__*/_react["default"].createElement(_Backdrop["default"], {
    onClick: toggleSubNav,
    hasVisibility: isSubNavVisible
  })), /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    "in": isSubNavVisible,
    timeout: 50,
    classNames: "slide-in"
  }, /*#__PURE__*/_react["default"].createElement(_MobileSubNav["default"], {
    ariaLabel: ariaLabelSubNavigation,
    LinkComponent: LinkComponent,
    items: moreItems,
    closeFunction: toggleSubNav
  }))) : null, /*#__PURE__*/_react["default"].createElement(_MobileNavMenu["default"], {
    ariaLabel: ariaLabel,
    LinkComponent: LinkComponent,
    items: mainItems,
    hasMoreItems: moreItems.length > 0,
    isMoreActive: isMoreActive,
    mobileMoreText: mobileMoreText,
    onClick: toggleSubNav
  }));
};

MobileNavigation.propTypes = {
  LinkComponent: _propTypes.elementType.isRequired,
  items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    name: _propTypes.string.isRequired,
    Icon: _propTypes.elementType,
    to: _propTypes.string.isRequired
  })).isRequired,
  ariaLabel: _propTypes.string.isRequired,
  ariaLabelSubNavigation: _propTypes.string.isRequired,
  mobileMoreText: _propTypes.string.isRequired,
  pathname: _propTypes.string.isRequired
};
var _default = MobileNavigation;
exports["default"] = _default;